import { Box, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { t } from 'i18next';
import toast from 'react-hot-toast';
import { useAppSelector } from '../../../../redux/hooks';
import { toastStyles } from '../../../../utils/utils';

function EmptyBookings() {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const coachConfigurations = useAppSelector((state) => state.booking.coachConfigurations);
  const linkToCopy = `${process.env.REACT_APP_AUTH_SERVICE}/u/${coachConfigurations.url}`;
  const copyToClipboard = () => {
    navigator.clipboard.writeText(linkToCopy);
    toast.success(t('common.copied'), toastStyles.success);
  };
  const isIpadMini = useMediaQuery('(max-width: 768px)');
  const configErr =
    coachConfigurations.calendar === null ||
    (coachConfigurations.isProvideOnlineConsultations &&
      coachConfigurations.videoCallPlatform === null);

  const getScreenHeight = () => {
    if (isIpadMini) {
      return configErr ? '35vh' : '40vh';
    }
    if (isSmallScreen) {
      return '40vh';
    }
    if (configErr) {
      return '60vh';
    }
    return '77vh';
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: getScreenHeight(),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: '2px',
        borderRadius: '16px',
        overflowX: 'auto',
        border: 'none',
        transform: isIpadMini ? 'scale(0.8)' : 'none',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '25px',
          width: '100%',
        }}
      >
        <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
          <img src="/assets/icons/bookings-empty.svg" alt="bookings" />
        </Box>
        <Box
          sx={{ alignContent: 'center', textAlign: 'center' }}
          maxWidth={isMediumScreen ? 300 : 600}
        >
          <Typography variant="title2Bold" color="primary">
            {t('bookings.viewbookings.emptyBookingsForSelectedDay')}
          </Typography>
        </Box>
        <Box
          sx={{ alignContent: 'center', textAlign: 'center' }}
          maxWidth={isMediumScreen ? 300 : 600}
        >
          <Typography variant="bodyRegular" textAlign="center" color="primary">
            {t('bookings.viewbookings.emptyBookingsForSelectedDayDesc')}
          </Typography>
        </Box>
        <Box
          sx={{
            padding: '16px 24px',
            borderRadius: '10px',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto',
            overflowY: 'auto',
            backgroundColor: 'rgba(124, 174, 190, 0.2)',
          }}
        >
          <Tooltip
            title={linkToCopy}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: 'primary.main',
                  borderRadius: '5px',
                  padding: '8px 12px',
                },
              },
            }}
          >
            <Typography
              variant="bodyBold"
              px={1}
              color="primary"
              maxWidth={isMediumScreen ? 300 : 500}
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                direction: 'ltr',
              }}
            >
              {linkToCopy}
            </Typography>
          </Tooltip>
          <button
            type="button"
            style={{ background: 'transparent', border: 'none' }}
            onClick={copyToClipboard}
          >
            <img
              src="/assets/icons/bookings-copy.svg"
              alt="bookings"
              style={{ cursor: 'pointer' }}
            />
          </button>
        </Box>
      </Box>
    </Box>
  );
}

export default EmptyBookings;
